/* Lafis · features.js — countdown, tabs, lookbook, quick view, wishlist, back-to-top */
(() => {
  'use strict';

  function formatMoney(cents) {
    const format = window.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withComma = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, `${withComma}.${dec}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, int.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---------- Toast ---------- */
  let toastEl, toastTimer;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2400);
  }

  /* ---------- Countdown timers ---------- */
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    const cells = {
      d: el.querySelector('[data-cd-days]'),
      h: el.querySelector('[data-cd-hours]'),
      m: el.querySelector('[data-cd-mins]'),
      s: el.querySelector('[data-cd-secs]')
    };
    const pad = (n) => String(n).padStart(2, '0');
    function tick() {
      const diff = Math.max(0, target - Date.now());
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor(diff / 3600000) % 24;
      const mins = Math.floor(diff / 60000) % 60;
      const secs = Math.floor(diff / 1000) % 60;
      if (cells.d) cells.d.textContent = days;
      if (cells.h) cells.h.textContent = pad(hours);
      if (cells.m) cells.m.textContent = pad(mins);
      if (cells.s) cells.s.textContent = pad(secs);
      if (diff === 0) clearInterval(timer);
    }
    tick();
    const timer = setInterval(tick, 1000);
  });

  /* ---------- Product tabs ---------- */
  document.querySelectorAll('[data-product-tabs]').forEach((wrap) => {
    const tabs = wrap.querySelectorAll('.product-tabs__tab');
    const panels = wrap.querySelectorAll('.product-tabs__panel');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t, j) => {
          t.classList.toggle('is-active', i === j);
          t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        });
        panels.forEach((p, j) => p.classList.toggle('is-active', i === j));
      });
    });
  });

  /* ---------- Lookbook hotspots ---------- */
  document.querySelectorAll('[data-lookbook]').forEach((lookbook) => {
    const hotspots = lookbook.querySelectorAll('.lookbook__hotspot');
    hotspots.forEach((spot) => {
      spot.addEventListener('click', (e) => {
        e.stopPropagation();
        const id = spot.dataset.hotspot;
        const pop = lookbook.querySelector(`.lookbook__popover[data-popover="${id}"]`);
        const wasOpen = pop && pop.classList.contains('is-open');
        lookbook.querySelectorAll('.lookbook__popover.is-open, .lookbook__hotspot.is-open')
          .forEach((el) => el.classList.remove('is-open'));
        if (pop && !wasOpen) {
          pop.classList.add('is-open');
          spot.classList.add('is-open');
          const x = parseFloat(spot.style.getPropertyValue('--x'));
          const y = parseFloat(spot.style.getPropertyValue('--y'));
          pop.style.insetInlineStart = `min(max(${x}%, 8%), 60%)`;
          pop.style.insetBlockStart = `${Math.min(y + 6, 78)}%`;
        }
      });
    });
    document.addEventListener('click', () => {
      lookbook.querySelectorAll('.lookbook__popover.is-open, .lookbook__hotspot.is-open')
        .forEach((el) => el.classList.remove('is-open'));
    });
  });

  /* ---------- Quick view ---------- */
  const qv = document.getElementById('QuickView');
  let qvProduct = null;

  function qvClose() {
    if (qv) { qv.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); }
  }
  if (qv) {
    qv.querySelector('.quick-view__backdrop').addEventListener('click', qvClose);
    qv.querySelector('.quick-view__close').addEventListener('click', qvClose);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') qvClose(); });
  }

    function qvSelectedVariant() {
    const selects = qv.querySelectorAll('.quick-view__option select');
    const opts = [...selects].map((s) => s.value);
    // If no option selects exist (single-variant product), use the first variant
    if (!opts.length) return qvProduct.variants[0];
    return qvProduct.variants.find((v) => v.options.every((o, i) => o === opts[i]));
  }


  function qvRefresh() {
    const variant = qvSelectedVariant();
    const priceEl = qv.querySelector('[data-qv-price]');
    const btn = qv.querySelector('[data-qv-add]');
    const img = qv.querySelector('[data-qv-image]');
    if (!variant) {
      btn.setAttribute('disabled', '');
      btn.querySelector('.button__label').textContent = window.variantStrings.unavailable;
      return;
    }
    priceEl.innerHTML = variant.compare_at_price > variant.price
      ? `<span class="price__sale-price">${formatMoney(variant.price)}</span> <s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`
      : `<span>${formatMoney(variant.price)}</span>`;
    if (variant.available) {
      btn.removeAttribute('disabled');
      btn.querySelector('.button__label').textContent = window.variantStrings.addToCart;
    } else {
      btn.setAttribute('disabled', '');
      btn.querySelector('.button__label').textContent = window.variantStrings.soldOut;
    }
    if (variant.featured_image && img) img.src = variant.featured_image.src;
    btn.dataset.variantId = variant.id;
  }

  async function qvOpen(handle) {
    if (!qv) return;
    try {
      const res = await fetch(`/products/${handle}.js`);
      qvProduct = await res.json();
    } catch { return; }

        qv.querySelector('[data-qv-title]').textContent = qvProduct.title;
    qv.querySelector('[data-qv-link]').href = qvProduct.url;
    const img = qv.querySelector('[data-qv-image]');
    if (img) {
      const imgSrc = typeof qvProduct.featured_image === 'string' ? qvProduct.featured_image : qvProduct.featured_image?.src;
      img.src = imgSrc || '';
      img.alt = qvProduct.title;
      console.log('Quick View - featured_image:', qvProduct.featured_image);
      console.log('Quick View - imgSrc set to:', img.src);
    }



    const optsWrap = qv.querySelector('[data-qv-options]');
    optsWrap.innerHTML = '';
        // product.js returns options either as strings or as { name, values } objects.
    const optionNames = qvProduct.options.map((o) => (typeof o === 'string' ? o : o.name));
    if (!(optionNames.length === 1 && optionNames[0] === 'Title')) {
      optionNames.forEach((name, i) => {
        const values = [...new Set(qvProduct.variants.map((v) => v.options[i]))];
        const field = document.createElement('div');
        field.className = 'quick-view__option';
        const label = document.createElement('label');
        label.textContent = name;
        const wrap = document.createElement('div');
        wrap.className = 'select';
        const select = document.createElement('select');
        select.className = 'select__select';
        values.forEach((v) => { select.add(new Option(v, v)); });
        select.addEventListener('change', qvRefresh);
        wrap.appendChild(select);
        field.append(label, wrap);
        optsWrap.appendChild(field);
      });
    }

    qvRefresh();
    qv.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (trigger) { e.preventDefault(); qvOpen(trigger.dataset.quickView); }
  });

  if (qv) {
    qv.querySelector('[data-qv-add]').addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      const id = parseInt(btn.dataset.variantId, 10);
      if (!id || !window.LafisCart) return;
      await window.LafisCart.add({ id, quantity: 1 }, btn);
      qvClose();
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  const WISHLIST_KEY = 'lafis:wishlist';
  const wishlistStrings = window.wishlistStrings || {};

  const Wishlist = {
    get() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch { return []; }
    },
    set(items) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      this.refreshUI();
    },
    toggle(handle) {
      const items = this.get();
      const idx = items.indexOf(handle);
      if (idx > -1) { items.splice(idx, 1); toast(wishlistStrings.removed || 'Removed from wishlist'); }
      else { items.push(handle); toast(wishlistStrings.added || 'Added to wishlist'); }
      this.set(items);
    },
    refreshUI() {
      const items = this.get();
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = items.length;
        el.classList.toggle('hidden', items.length === 0);
      });
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        btn.classList.toggle('is-wishlisted', items.includes(btn.dataset.wishlistToggle));
      });
    },
    async renderDrawer() {
      const list = document.querySelector('[data-wishlist-items]');
      const empty = document.querySelector('[data-wishlist-empty]');
      if (!list) return;
      const items = this.get();
      empty && empty.classList.toggle('hidden', items.length > 0);
      list.classList.toggle('hidden', items.length === 0);
      list.innerHTML = '';
      const products = await Promise.all(items.map((h) =>
        fetch(`/products/${h}.js`).then((r) => r.ok ? r.json() : null).catch(() => null)
      ));
      products.filter(Boolean).forEach((p) => {
        const row = document.createElement('div');
        row.className = 'cart-drawer__item';
        row.innerHTML = `
          <a href="${p.url}"><img src="${p.featured_image || ''}" alt="" width="80" height="80" loading="lazy"></a>
          <div>
            <a class="cart-drawer__item-title" href="${p.url}">${p.title}</a>
            <div class="cart-drawer__item-meta">${formatMoney(p.price)}</div>
            <div class="cart-drawer__item-row">
              <button type="button" class="button button--small" data-quick-view="${p.handle}">${wishlistStrings.view || 'View'}</button>
              <button type="button" class="cart-item__remove" style="background:none;border:0;cursor:pointer;" data-wishlist-remove="${p.handle}">${wishlistStrings.remove || 'Remove'}</button>
            </div>
          </div>`;
        list.appendChild(row);
      });
    }
  };

  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      Wishlist.toggle(toggleBtn.dataset.wishlistToggle);
      return;
    }
    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      const items = Wishlist.get().filter((h) => h !== removeBtn.dataset.wishlistRemove);
      Wishlist.set(items);
      Wishlist.renderDrawer();
      return;
    }
    const opener = e.target.closest('[data-drawer-open="WishlistDrawer"]');
    if (opener) Wishlist.renderDrawer();
  });
  Wishlist.refreshUI();

  /* ---------- Back to top ---------- */
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
})();
